import { render, staticRenderFns } from "./InterfaceManagement.vue?vue&type=template&id=e3035640&"
import script from "./InterfaceManagement.vue?vue&type=script&lang=js&"
export * from "./InterfaceManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports